/* template */
<template><div class="texts"><div v-for="(item, index) in (tableValue)" :key="item.index" class="text"><div v-for="(text, idx) in (item)" :key="text.idx" class="column"><div class="title">{{text.text}}</div><div class="sub-text" v-if="(text.subText)">{{text.subText}}</div></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4efba4ee"}'>
.texts
  white-space pre-wrap
  margin 0 12px 12px
  font-size 14px
  line-height 1.3
  color #666
  font-family PingFangSC-Regular
  font-weight normal
  .text
    border-left 0.5px solid rgba(0, 0, 0, 0.08)
    border-right 0.5px solid rgba(0, 0, 0, 0.08)
    border-bottom 0.5px solid rgba(0, 0, 0, 0.08)
    display flex
    &:first-child
      border-top 0.5px solid rgba(0, 0, 0, 0.08)
      border-top-left-radius 8px
      border-top-right-radius 8px
      background rgba(231, 241, 255, 0.3)
      .title
        font-family PingFangSC-Medium
        margin-bottom 2px
      .sub-text
        font-size 12px
    &:last-child
      border-bottom-left-radius 8px
      border-bottom-right-radius 8px
    .column
      padding 10px
      flex 1
      border-right 0.5px solid rgba(0, 0, 0, 0.08)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m4efba4ee"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./common-table.mpx.js?isComponent&outputPath=components%2Fcommon-table4efba4ee%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./common-table.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcommon-table4efba4ee%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m4efba4ee"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/common-table4efba4ee/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
